import { withShowIf } from '../../../ui-library/helpers/with-show-if/with-show-if.component'
import { spinnerIconStyle } from './spinner.icon.style'
import { SpinnerIconProps } from './spinner.icon.props'

export const SpinnerIcon = withShowIf((props: SpinnerIconProps) => {
  const style: string = spinnerIconStyle(props.size, props.cssClasses)
  return <div className={style} />
})
